/*import Vue from 'vue'*/

import ConstUtils from '@/utils/ConstUtils.js';
import EventUtils from '@/utils/EventUtils.js';
import MapUtils from '@/utils/MapUtils.js';

const state = {
  list: [],
  map: {},
};

const getters = {
    EmployeeRecordStorage_State: state => state,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event.status == EventUtils.STATUS.COMPLETE && event.statusCode == EventUtils.CODE.OK) {
      if (event.Payload && event.Payload.EmployeeRecordMap) {
        var records = event.Payload.EmployeeRecordMap;
        state.map = MapUtils.updateMap(records, state.map);
        state.list = Object.values(state.map);
      }
      if (event.Payload && event.Payload.EmployeeRecord) {
        var record = event.Payload.EmployeeRecord;
        state.map[record[ConstUtils.FIELDS.ID]] = record;
        state.list = Object.values(state.map);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};